import { Grid, Typography, styled } from '@mui/material';
import { FileUpload, InputOnlyField } from '@ngt/forms';
import { FC } from 'react';

const StyledTypography = styled(Typography)(({theme}) => ({
    paddingBottom: theme.spacing(2),
}))

const SpeakerUploadsFields: FC = () => {
    return (
        <>
            <Grid  
                item
                sm={12}
            >
                <Typography variant='h2'>
                    Uploads
                </Typography>
            </Grid>
            <Grid  
                item
                sm={12}
            >
                <StyledTypography variant='body1'>
                    Please upload a speaker bio of up to 500 words (pdf or word document), and profile picture. This bio and picture will be added to the conference website, conference app and printed program. Please note: the BCT Communications Department may reach out to you requesting a video or podcast interview during your time at the 47th ASM.
                </StyledTypography>
            </Grid>

            <Grid
                item
                xs={12}
                sm={6}
                md={6}
            >
                <Typography 
                    variant='h4'
                    sx={{paddingBottom: '8px'}}
                >
                    Speaker Bio
                </Typography>
                <InputOnlyField
                    propertyPath="speakerBio"
                    component={FileUpload}
                />
            </Grid>

            <Grid
                item
                xs={12}
                sm={6}
                md={6}
            >
                <Typography 
                    variant='h4'
                    sx={{paddingBottom: '8px'}}
                >
                    Speaker Photo
                </Typography>
                <InputOnlyField
                    propertyPath="speakerPhoto"
                    component={FileUpload}
                />
            </Grid>

            <Grid  
                item
                sm={12}
            >
                <Typography variant='body1'>
                    <i>Disclaimer: The above bio and pic will be used as promotional material on our conference website, and may be used on our social media channels. As a placeholder BCT will source current bio and profile picture information as available on the Internet. It is a speaker's responsibility to provide their up-to-date biography and a high quality photograph (675W x 674H or at least 300DPI) by <strong> Friday 12th June 2026. </strong> Changes to speaker information for the printed program are unable to be made after this date. Changes to speaker information on the conference website and app are unable to be made after<strong> Wednesday 1st July 2026. </strong></i>
                </Typography>
            </Grid>
        </>
    );
}

export default SpeakerUploadsFields;
